import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import styled from 'styled-components';
import query from '../../../const/mediaQueries';
import { colors, opacities } from '../../../defaultTheme';
import modalKeyboardHandler from '../../../helpers/modalKeyboardHandler';
import Button from '../../atoms/Button';
// shared header/footer styles
export const sharedElementStyles = `
  display: flex;
  align-items: center;
  padding: 16px;
`;
// darkened overlay styles - need to use pseudo element
export const Overlay = styled.div `
  ${({ isOpen }) => isOpen &&
    `
    :after {
      content: "";
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 1;
      background-color: ${opacities.rgbaHalfOpacity};
    }
  `}
`;
/**
 * Height where header and footer start to occupy half of the vertical viewport
 * making hard to read the modal content when applying zoom, starting from 360px
 * which is equivalent to:
 * 200% zoom at 720px height
 * 300% zoom at 1080px height
 */
const MIN_VIEWPORT_HEIGHT = '360px';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  text-align: left;
  position: fixed;
  top: 0;
  z-index: 2;
  right: -768px;
  background-color: ${colors.white};
  width: 100vw;
  height: 100%;
  transition: right 400ms ease-in-out;

  @media ${query.greaterThanMedium} {
    max-width: 768px;
    box-shadow: -6px 0 20px 0 ${opacities.rgbaLight12};
  }

  @media (max-height: ${MIN_VIEWPORT_HEIGHT}) {
    overflow-y: scroll;
  }
`;
export const ModalContentWrapper = styled.div `
  overflow-y: auto;
  height: 100%;

  @media (max-height: ${MIN_VIEWPORT_HEIGHT}) {
    overflow-y: visible;
    height: auto;
  }
`;
export const ModalWrapper = ({ modalRef, ariaLabel, id, className, escapeModalHandler, children }) => {
    const keyListener = (e) => modalKeyboardHandler(e, { escapeHandler: escapeModalHandler });
    useEffect(() => {
        document.addEventListener('keydown', keyListener);
        return () => document.removeEventListener('keydown', keyListener);
    });
    return (_jsx(Container, Object.assign({ ref: modalRef, "aria-label": ariaLabel, id: id, className: className, role: "dialog" }, { children: children })));
};
/**
 * Reason to add conditional style based on footer prop is:
 * if we are adding display flex to modal content, footer is not properly aligned on storybook knob - SlideInModal in safari browser.
 * Since added conditional style to address the safari issue.
 */
export const ModalContent = styled.div `
  ${({ hasFooter }) => !hasFooter &&
    `
      display: flex;
      flex-direction: column;
    `}

  flex-grow: 1;
  flex-shrink: 0;
  min-height: 100%;
`;
export const FooterButton = styled(Button) `
  margin: 0;
  min-width: 100%;
  margin-bottom: 8px;

  @media ${query.greaterThanMedium} {
    min-width: 220px;
    min-height: 48px;
    margin-bottom: 0;
    margin-left: 8px;
  }
`;
export const FooterWrapper = styled.div `
  background: ${colors.lightestGrey};
  ${sharedElementStyles}
  flex-direction: column-reverse;
  justify-content: center;
  border-top: 1px solid ${colors.lightGrey};
  box-sizing: border-box;

  @media ${query.greaterThanMedium} {
    height: 96px;
    min-height: 96px;
    padding: 0 24px;
    flex-direction: row;
    justify-content: flex-end;
  }
`;
//# sourceMappingURL=subcomponents.js.map